// extracted by mini-css-extract-plugin
export default {"container":"container__Rfyme","search":"search__apFuR","title":"title__f7OTs","list":"list__4h-x7"};